"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneContattoDtoToJSON = exports.CertificazioneContattoDtoFromJSONTyped = exports.CertificazioneContattoDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function CertificazioneContattoDtoFromJSON(json) {
    return CertificazioneContattoDtoFromJSONTyped(json, false);
}
exports.CertificazioneContattoDtoFromJSON = CertificazioneContattoDtoFromJSON;
function CertificazioneContattoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ndg': !runtime_1.exists(json, 'ndg') ? undefined : json['ndg'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
        'dataUltimaModifica': !runtime_1.exists(json, 'dataUltimaModifica') ? undefined : (new Date(json['dataUltimaModifica'])),
        'dataCertificazione': !runtime_1.exists(json, 'dataCertificazione') ? undefined : (json['dataCertificazione'] === null ? null : new Date(json['dataCertificazione'])),
    };
}
exports.CertificazioneContattoDtoFromJSONTyped = CertificazioneContattoDtoFromJSONTyped;
function CertificazioneContattoDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ndg': value.ndg,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
        'dataUltimaModifica': value.dataUltimaModifica === undefined ? undefined : (value.dataUltimaModifica.toISOString()),
        'dataCertificazione': value.dataCertificazione === undefined ? undefined : (value.dataCertificazione === null ? null : value.dataCertificazione.toISOString()),
    };
}
exports.CertificazioneContattoDtoToJSON = CertificazioneContattoDtoToJSON;
